export default __webpack_public_path__ + "static/media/Zuber FrontEnd CV.5dbf4dcc.pdf";